import React from 'react'
import { useNavigate } from 'react-router-dom'

import { FormStatus } from '../enums'
import { useFormListQuery } from '../hooks'
import { Card, Page, PageHeader, DataTable, ButtonAdd } from 'components'

const COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id'
  },
  {
    Header: 'Nome',
    accessor: 'name'
  },
  {
    Header: 'Data Inicio',
    accessor: 'beginDate'
  },
  {
    Header: 'Data Fim',
    accessor: 'endDate'
  },
  {
    Header: 'Setor',
    accessor: 'sector.name'
  },
  {
    Header: 'Estado',
    accessor: data => FormStatus.toString(data.status)
  }
]

export const FormListPage = () => {
  const navigate = useNavigate()
  const { data, error, loading, pageSize, pageIndex, fetchPage, setPageSize } = useFormListQuery()

  const onRowClick = row => navigate(`${row.original.id}`)

  if (error) {
    return navigate('/login')
  }

  const pageCount = Math.ceil(data?.formList?.totalCount / pageSize)

  return (
    <Page>
      <PageHeader heading='Gerir Questionários' onBack={() => navigate('..')}>
        <ButtonAdd onClick={() => navigate('criar')} />
      </PageHeader>

      <Card p={3}>
        {/*
        <DataTable2
          data={data.formList.results}
          head={
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Nome</Th>
                <Th>Data de Inicio</Th>
              </Tr>
            </Thead>
          }>
          {row => (
            <Tr>
              <Td>{row.id}</Td>
              <Td>{row.name}</Td>
              <Td>{row.beginDate}</Td>
            </Tr>
          )}
        </DataTable2>
        */}
        <DataTable
          columns={COLUMNS}
          loading={loading}
          data={data?.formList?.results}
          onRowClick={onRowClick}
          onPage={fetchPage}
          onPageSize={setPageSize}
          pageIndex={pageIndex}
          pageCount={pageCount}
        />
      </Card>
    </Page>
  )
}

export default FormListPage
